module.exports = __webpack_public_path__ + "img/retail_order_placed.f1c2f946.jpg";